// external
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// state managing/secrity
import { FaoBuilderContext } from "context/FaoBuilderContext";

// assets
import Icons from "assets/icons";

function FaoCreate() {
  const navigate = useNavigate();
  const { createNewModel } = useContext(FaoBuilderContext);
  const handleCreateNew = async () => {
    try {
      const model = await createNewModel();
      if (!model?.id) {
        throw new Error("Created model is missing ID");
      }
      navigate(`../fao-builder/${model.id}/metadata`);
    } catch (error) {
      console.error("Error creating model:", error);
      toast.error(error.message || "Failed to create new model");
    }
  };
  return (
    <div className="flex h-full flex-col justify-between">
      <div className="flex h-full w-full flex-col">
        <div className="mb-8">
          <h1 className="text-2xl font-semibold text-blue-03">New FAO Model</h1>
          <div className="flex">
            <Icons.Info customClass="h-4 w-4 text-gray-500 mr-1 mt-1" />
            <p className="text-gray-500">
              This page allows you to create a new FAO model from scratch or use
              an existing FAO model as a template.
            </p>
          </div>
        </div>
        <div className="flex gap-6">
          <button
            onClick={handleCreateNew}
            className="flex flex-1 items-start gap-4 rounded-lg border border-solid border-blue-01 bg-white p-6 hover:bg-gray-50"
          >
            <Icons.Plus className="mt-1 h-6 w-6 text-blue-03" />
            <div className="flex flex-col items-start">
              <span className="text-lg font-semibold text-blue-03">
                New Model from Scratch
              </span>
              <span className="text-sm text-gray-600">
                Create a new FAO model configuration
              </span>
            </div>
          </button>

          <button
            className="flex flex-1 items-start gap-4 rounded-lg border border-solid border-blue-01 bg-white p-6 hover:bg-gray-50"
            onClick={() => navigate("../fao-builder/clone")}
          >
            <Icons.Copy className="mt-1 h-6 w-6 text-blue-03" />
            <div className="flex flex-col items-start">
              <span className="text-lg font-semibold text-blue-03">
                Start from an existing FAO Model
              </span>
              <span className="text-sm text-gray-600">
                Use an existing FAO model as template
              </span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}

export default FaoCreate;
